// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "disclaimer__wrp-2jX4K";
var _3 = "disclaimer_columnContent-IMwRF";
var _4 = "disclaimer-msVba";
var _5 = "disclaimer__icon_info-MO9ZW";
export { _1 as "__esModule", _2 as "disclaimer__wrp", _3 as "disclaimer_columnContent", _4 as "disclaimer", _5 as "disclaimer__icon_info" }
export default { "__esModule": _1, "disclaimer__wrp": _2, "disclaimer_columnContent": _3, "disclaimer": _4, "disclaimer__icon_info": _5 }
